import request from '@/utils/request'

//Login
export function reorderhistory(page) {
  return request({ url: 'vreorder', method: 'post', data: {'page': page} })
} 
